import { Tenant } from "redmond";
import { isCorpTenant } from "./getTenant";

export const getSupportNumber = (tenant: Tenant) =>
  isCorpTenant(tenant) ? "833-233-5660" : "844-422-6922";
